import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { FEATURE_FLAGS } from 'utils/constants';
import { useFeatureFlags } from 'v2/hooks/useFeatureFlags';
import { ProposalEntity, RootState, SearchEntity } from 'v2/models';
import { useSelector } from 'react-redux';
import DataProviderResponse from '../DataProviderResponse';
import InfoNoResponseYet from './InfoNoResponseYet';

interface IShowMoreRequestItem {
  proposal: ProposalEntity;
}

const ShowMoreRequestItem = ({ proposal }: IShowMoreRequestItem) => {
  const search = proposal.search as SearchEntity;

  const location = useLocation();
  const user = useSelector((state: RootState) => state.user.user);

  const [isSellerSearchDetailsEnabled] = useFeatureFlags([
    FEATURE_FLAGS.SELLER_SEARCH_DETAILS,
  ]);
  const [showMore, setShowMore] = useState(
    Number(location.hash.slice(1)) === proposal.id
  );

  const hasProviderResponse = [
    !!proposal.data_provider_response?.response,
    !!proposal.data_provider_response?.answers?.length,
    !!proposal.data_provider_response?.data_files?.length,
  ].some(Boolean);

  const showExpandButton = [
    !!search.questions.length,
    !!search.filters.length,
    hasProviderResponse,
  ].some(Boolean);

  if (isSellerSearchDetailsEnabled) {
    return (
      <Link
        to={{
          pathname: `/data-request-details/${proposal.id}/detail`,
          state: { comingFromPath: location.pathname },
        }}
      >
        View full request
      </Link>
    );
  }

  return (
    <>
      {showMore && !hasProviderResponse && (
        <InfoNoResponseYet search={search} />
      )}
      {showExpandButton && (
        <Button
          className="p-0"
          variant="link"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? 'Show Less' : 'Show More'}
        </Button>
      )}
      {showMore && (
        <div>
          {hasProviderResponse && (
            <DataProviderResponse proposal={proposal} user={user} />
          )}
          {proposal.data_buyer_response?.action === 'negative' && (
            <Alert variant="danger" className="mt-4">
              <p className="text-primary-dark">Buyer Rejection Reason</p>
              <p className="text-light4">
                {proposal.data_buyer_response.response}
              </p>
            </Alert>
          )}
        </div>
      )}
    </>
  );
};

export default ShowMoreRequestItem;
